import { Hero } from "../components/home/Hero";
import { TrustRow } from "../components/home/TrustRow";
import { Categories } from "../components/home/Categories";
import { Marquee } from "../components/site/Marquee";
import { Trending } from "../components/home/Trending";
import { Lifestyle } from "../components/home/Lifestyle";
import { Newsletter } from "../components/home/Newsletter";
import { PromoTiles } from "../components/home/PromoTiles";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustRow />
      <Categories />
      <Marquee />
      <Trending />
      <Lifestyle />
      <Newsletter />
      <PromoTiles />
    </main>
  );
}
